var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cnmn-validate",class:{
    'cnmn-validate--error': 0 < _vm.errors.length,
    'cnmn-validate--touch': _vm.touched,
  }},[_vm._t("default",null,{"errors":_vm.errors,"hasError":0 < this.errors.length,"touch":_vm.touch,"touched":_vm.touched})],2)}
var staticRenderFns = []

export { render, staticRenderFns }